<div class="h-full flex flex-col z-0 relative overflow-y-auto">
  <div
    class="px-4 py-2 border-b border-zinc-950/10 dark:border-white/10 flex flex-wrap justify-between items-center gap-4">
    <h3 class="text-lg font-medium leading-6 text-main-dark">
      Notifications
    </h3>
    <div class="flex-1 flex justify-center">
      <span class="text-xs whitespace-nowrap">
        Showing {{(notifications | filter:search).length}} entries</span>
    </div>
    <div class="flex flex-wrap items-center gap-2">

      <!-- Datepicker -->
      <div class="relative w-full flex-shrink sm:w-auto">
        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" aria-hidden="true">
          <svg class="h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z" />
          </svg>
        </div>
        <div class="relative">
          <input type="text" class="form-control" [(ngModel)]="dateRange" (ngModelChange)="onDateRangeChange($event)"
            placeholder="From - To" [selectMode]="'range'" [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2" />
          <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
        </div>
      </div>

      <!-- Datepicker end -->

      <div class="relative">
          <!-- Heroicon name: mini/magnifying-glass -->
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="absolute z-50 left-2 top-1/2 transform -translate-y-1/2 size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
        </svg>
        <input type="text" name="search" id="search" class="pl-9" placeholder="Search" [(ngModel)]="search"
          autocomplete="off" />
      </div>

    </div>
  </div>
  <ul *ngIf="notifications.length" role="list" class="px-4 py-2 flex-1 divide-y overflow-y-auto divide-zinc-950/10 dark:divide-white/10 bg-white mr-2 dark:bg-zinc-950">
    <li *ngFor="let notification of notifications | filter:search; trackBy: trackById">
      <div class="group relative flex items-center py-4">
        <a class="-m-1 block flex-1 p-1 cursor-pointer" (click)="onNotificationClick(notification)">
          <div class="absolute inset-0 group-hover:bg-main-base-50" aria-hidden="true">
          </div>
          <div class="relative flex min-w-0 flex-1 items-start gap-2 text-xs text-main-secondary">
            <div class="flex flex-col w-full">
              <div class="flex justify-between items-center">
                <div>
                  <div *ngIf="notification" class="font-bold">{{notification.title | capitalize}}</div>
                </div>
              </div>
              <div>
                <p class="text-main-light">
                  {{notification.message}}
                </p>
                <p class="text-main-light">
                  {{notification.createdAt | date:'MM/DD/YYYY HHmm'}}
                </p>
              </div>
            </div>
          </div>
        </a>
      </div>
    </li>
  </ul>
  <div *ngIf="!notifications.length" class="p-4">
    <div class="relative block w-full rounded-lg border-2 border-dashed border-zinc-950/10 dark:border-white/10 p-12 text-center">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="mx-auto h-12 w-12 text-main-light">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M3 8.25V18a2.25 2.25 0 002.25 2.25h13.5A2.25 2.25 0 0021 18V8.25m-18 0V6a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 6v2.25m-18 0h18M5.25 6h.008v.008H5.25V6zM7.5 6h.008v.008H7.5V6zm2.25 0h.008v.008H9.75V6z" />
      </svg>
      <span class="mt-2 block font-medium text-main-dark">No notifications to show</span>
    </div>
  </div>
</div>